export const DOMAIN_URL = process.env?.REACT_APP_API_URL_;
export const API_VERSION = process.env?.REACT_APP_API_VERSION_ || "";
export const BASE_URL = DOMAIN_URL + API_VERSION;
export const APIKEY = process.env?.REACT_APP_APIKEY_;
export const ENV_NAME = process.env?.REACT_APP_ENV_NAME_ || "";
